import classnames from 'classnames/bind';

import { useAccessTokens } from 'hooks/api/useAccessTokens';

import * as PageLayout from 'components/PageLayout';
import { ExternalLink } from 'components/ExternalLink/ExternalLink';
import { Heading } from 'components/Heading/Heading';

import { TokenForm } from '../../components/TokenForm/TokenForm';
import { TokenTable } from '../../components/TokenTable/TokenTable';
import { UniversalBridgeInfo } from '../../components/UniversalBridgeInfo/UniversalBridgeInfo';
import styles from '../Settings.module.scss';

const c = classnames.bind(styles);

export function UniversalBridge() {
  const { data: accessTokens, isLoading } = useAccessTokens();

  const universalBridgeTokens = accessTokens?.filter(
    ({ type }) => type === 'mintable'
  );

  return (
    <PageLayout.Root size="medium">
      <PageLayout.Container>
        <div className={c('wrap')}>
          <div className={c('header')}>
            <div>
              <Heading level="2">Virtual cameras</Heading>
              <ExternalLink href="https://docs.lumeo.com/docs/universal-bridge">
                Virtual camera docs
              </ExternalLink>
            </div>
          </div>

          <UniversalBridgeInfo />

          <section className={c('section')}>
            <TokenForm
              title="Generate new Virtual Camera token"
              defaultExpiration="No expiration"
              types={['mintable']}
            />
          </section>

          <TokenTable tokens={universalBridgeTokens} isLoading={isLoading} />
        </div>
      </PageLayout.Container>
    </PageLayout.Root>
  );
}
